import React, { useState } from 'react';
import './style.scss';

// Accessible FAQ accordion. The visible Q&A here must match the FAQPage JSON-LD
// so the structured data is valid (Google requires FAQ content on the page).
const FaqSection = ({ title = 'Frequently Asked Questions', subTitle = 'Your Questions, Answered', faqs = [] }) => {
    const [open, setOpen] = useState(0);
    if (!faqs.length) return null;

    return (
        <section className="faqSection">
            <div className="container">
                <div className="faqHead">
                    <span>{subTitle}</span>
                    <h2>{title}</h2>
                </div>
                <div className="faqList">
                    {faqs.map((f, i) => {
                        const isOpen = open === i;
                        return (
                            <div className={`faqItem${isOpen ? ' open' : ''}`} key={i}>
                                <button
                                    type="button"
                                    className="faqQuestion"
                                    aria-expanded={isOpen}
                                    onClick={() => setOpen(isOpen ? -1 : i)}
                                >
                                    <span>{f.question}</span>
                                    <span className="faqIcon" aria-hidden="true">{isOpen ? '–' : '+'}</span>
                                </button>
                                <div className="faqAnswer" role="region">
                                    <p>{f.answer}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default FaqSection;
